import moment, { Moment } from 'moment'
import { OfferDiscountSource, OfferDiscountType } from 'constants/offer'
import { VILLAS_DISCOUNT_MAXIMUM_TRAVEL_PERIOD_RANGE } from 'constants/villas'
import { EmptyArray } from 'lib/array/arrayUtils'
import { isDateWithinAnyDiscountPeriod } from 'components/OfferPage/utils'

export function isAnyDayInMonthInDiscountPeriod(discounts: Array<App.Discount>, month: Moment, duration: number) {
  const daysInMonth = month.daysInMonth()
  return Array.from({ length: daysInMonth }, (_, i) => i + 1)
    .some(day => isDateWithinAnyDiscountPeriod(discounts, month.clone().date(day), duration))
}

// Discount travel periods can be further than our allowable booking window.
// We limit discount label to x months from today.

function isTravelPeriodWithinTimeFrame(schedules: Array<App.DiscountSchedule>, months: number) {
  const todayPlusMonths = moment().add(months, 'months')
  // if any schedules travel period on a discount extends beyond the allowable booking window, return false
  return !schedules.some(schedule => moment(schedule.travelPeriod.to) >= todayPlusMonths)
}

export function getBestVillasDiscounts(
  discounts: Array<App.Discount> = EmptyArray,
  maxDiscounts?: number,
  duration?: number,
  checkIn?: string,
) {
  // We only want to show internal (promotional aka scheduled discounts) if there are any internal ones.
  const internalDiscounts = discounts.filter(discount => discount.source === OfferDiscountSource.INTERNAL)

  return sortVillaDiscounts(internalDiscounts, duration, checkIn).slice(0, maxDiscounts)
}

const sortVillaDiscounts = (
  discounts: Array<App.Discount>,
  duration?: number,
  checkIn?: string,
) => {
  const topDiscounts = discounts
    .filter(discount => discount.discountType !== OfferDiscountType.LAST_MINUTE && isTravelPeriodWithinTimeFrame(discount.schedules, VILLAS_DISCOUNT_MAXIMUM_TRAVEL_PERIOD_RANGE))
    .sort((a, b) => b.discountPercent - a.discountPercent)

  if (duration && checkIn) {
    return topDiscounts.filter(discount => isDateWithinAnyDiscountPeriod([discount], moment(checkIn), duration))
  }

  return topDiscounts
}
